"use client";
import { useEffect, useState } from "react";
import type { Dispatch, SetStateAction } from "react";

export function useSessionStorage<T>(
  key: string,
  initialValue: T | number | boolean | string | object | null
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    if (typeof window !== "undefined" && window.sessionStorage) {
      const localValue = sessionStorage.getItem(key);
      if (localValue != null) return JSON.parse(localValue);
      return initialValue;
    }
  });

  useEffect(() => {
    if (typeof window !== "undefined" && window.sessionStorage) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  return [value, setValue];
}
